goog.provide('el8.ptdata.dcMedOrders');

goog.require('el8.model.base');
goog.require('el8.ptdata.model.med.dcMedOrder');
goog.require('el8.data.referencedPracticians');
goog.require('el8.service.urls');


el8.ptdata.dcMedOrders = (function() {
    var that = new el8_EntitySet({
        model: el8.ptdata.model.med.dcMedOrder,
        items: [],
        saveFn: function(item, successCb, errorCb, opts) {
            opts = opts || {};
            $.el8_ajax({
                type: 'POST',
                url: el8.service.urls.get('discontinueMedOrder', [item.getMedOrderId()]),
                async: (opts.async !== false), // defaults true
                data: {'data': JSON.stringify(item.asMap())},
                success: function(data) {
                    item.populate(data['dc_med_order']);
                    if (data['thread']) {  // if signed off
                        el8.ptdata.medOrderThreads.create(data['thread']); // notifies
                    }
                    if (data['new_physician']) {
                        el8.data.referencedPracticians.create(data['new_physician']);
                    }
                    if (successCb) { successCb(); }
                },
                error: errorCb
            });
        },
        deleteFn: function(item, successCb, errorCb, opts) {
            opts = opts || {};
            $.el8_ajax({
                type: 'DELETE',
                url: el8Globals['PATIENT_PATH']+"prescriptions/"+item.getId()+"/discontinue/",
                async: (opts.async !== false), // defaults true
                success: function(data) {
                    if (item.isSignedOff()) {
                        if (data['deleted_thread_id']) {
                            el8.ptdata.medOrderThreads.remove(data['deleted_thread_id']);
                        } else if (data['updated_thread']) {
                            el8.ptdata.medOrderThreads.create(data['updated_thread']);
                        }
                        if (data['remove_visitnote_references']) {
                            el8.appchart.visitNote.main.removeNewOrder(item);
                        } else if (data['remove_nonvisitnote_references']) {
                            el8.appchart.nonvisitNote.main.removeNewOrder(item);
                        }
                    }
                    if (successCb) { successCb(); }
                },
                error: errorCb
            });
        }
    });
    return that;
})();
